import React from 'react'
import Chip from '@mui/material/Chip'
import { Tooltip, Zoom } from '@mui/material'

interface ComponentProps {
  orderStatus: string | undefined
}

export const AssetOrderStatusChip: React.FC<ComponentProps> = ({ orderStatus }: ComponentProps) => {
  let variant: 'outlined' | undefined
  let color: 'primary' | 'warning' | 'error' | 'secondary' | 'success' | undefined

  if (orderStatus === 'PROCESSED') {
    color = 'primary'
    variant = 'outlined'
  } else if (orderStatus === 'PAYMENT_CONFIRMED') {
    color = 'success'
    variant = 'outlined'
  } else if (orderStatus === 'RESERVED') {
    color = 'secondary'
    variant = 'outlined'
  } else if (orderStatus === 'CANCELLED') {
    color = 'error'
    variant = 'outlined'
  }

  return (
    <>
      {orderStatus === undefined
        ? (
          <></>
          )
        : (
          <Tooltip title={orderStatus} TransitionComponent={Zoom} arrow placement='bottom'>
            <Chip label={orderStatus} variant={variant} color={color} />
          </Tooltip>
          )
      }
    </>
  )
}
